import { EUserType } from './users.types';

export enum EQuestionStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  DISMISSED = 'DISMISSED',
  DELETED = 'DELETED',
}

export enum EAnswerStatus {
  EMPTY = 'EMPTY',
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  ANSWERED = 'ANSWERED',
}

export enum EAnswerType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  LIVE = 'LIVE',
}
export interface IQuestionAuthor {
  id: string;
  recordId: string;
  uuid: string;
  name: string;
}

export interface IQuestionAssignee {
  id: string;
  uuid?: string;
  recordId: string;
  name: string;
}

export interface IQuestionAnswer {
  text: string;
  timestamp: string;
  status: EAnswerStatus;
  answerType?: EAnswerType;
  edited?: boolean;
}

export interface IQuestionReply extends IQuestionAnswer {
  id: string;
  questionId: string;
  roomId: string;
  createdAt: string;
  updatedAt: string;
  creator: IQuestionAssignee; // The user who replied to the question
}

export interface IQuestion {
  id: string;
  roomId: string;
  text: string;
  anonymous: boolean;
  status: EQuestionStatus;
  createAt: string;
  updateAt: string;
  creator: IQuestionAuthor;
  assignTo?: IQuestionAssignee;
  assignedBy?: IQuestionAssignee;
  answer?: IQuestionAnswer;
  edited?: boolean; // Flag to indicate if the question has been edited
  replies?: IQuestionReply[]; // Optional field to hold replies to the question
  userType?: EUserType; //TODO: temporary field to indicate the type of user (e.g., HOST, CO_HOST, SPEAKER)

  dismissedBy?: IQuestionAuthor;
}

export type TShowFilter =
  | 'ALL'
  | 'ANSWERED'
  | 'DISMISSED'
  | 'ASSIGNED_TO'
  | 'ANSWERED_BY_ME'
  | 'ANSWERED_IN_PUBLIC'
  | 'MY_QUESTIONS'
  | 'UNASSIGNED';

export type TSortFilter = 'NEWEST' | 'OLDEST';

export interface IQuestionAndAnswerFiltersProps {
  showValue: TShowFilter;
  sortValue: TSortFilter;
  onShowChange: (value: TShowFilter) => void;
  onSortChange: (value: TSortFilter) => void;
  currentPeerType: EUserType;
}

export interface IStatusLabelProps {
  question: IQuestion;
}

export interface IQuestionAndAnswerResponse {
  success: boolean;
  message: string;
  question: IQuestion;
}

export interface IQuestionAndAnswerFilterResponse {
  result: IQuestion[];
}
export interface IQuestionResponse {
  question: IQuestion;
}

export enum EQuestionAndAnswerSockets {
  SUBMIT_QUESTION = 'submitQuestion',
  EDIT_QUESTION = 'editQuestion',
  DELETE_QUESTION = 'deleteQuestion',
  ANSWER_QUESTION = 'answerQuestion',
  DISMISS_QUESTION = 'dismissQuestion',
  ASSIGN_QUESTION = 'assignQuestion',
  UNASSIGN_QUESTION = 'unassignQuestion',
  REPLY_TO_ANSWER = 'replyToAnswer',
  MARK_QUESTION_AS_ANSWERED = 'markQuestionAsAnswered',
  EDIT_ANSWER = 'editAnswer',
}
